import { ExpressionValue } from "../../ExpressionValue";
import { BaseLogicExpression } from "../Logic/BaseLogic";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class EqualExpression extends BaseLogicExpression {
    readonly __type: string = "Equal";
    value1: ExpressionValue;
    value2: ExpressionValue;

    constructor() {
        super();
        this.value1 = ExpressionValue.createExpressionValue(this, "value1");
        this.value2 = ExpressionValue.createExpressionValue(this, "value2");
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        const value1 = this.value1.evaluate(data, testContext);
        const value2 = this.value2.evaluate(data, testContext);
        return (value1 || value2) && value1 === value2;
    }
}
